import { render, staticRenderFns } from "./SummaryDropdown.vue?vue&type=template&id=3b8adef0&scoped=true&"
import script from "./SummaryDropdown.vue?vue&type=script&lang=js&"
export * from "./SummaryDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SummaryDropdown.vue?vue&type=style&index=0&id=3b8adef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8adef0",
  null
  
)

export default component.exports